  var $div = $('#carousel-first-image'),
  bg = $div.css('background-image');
  console.log('bg loaded');
  if (bg) {
    var src = bg.replace(/(^url\()|(\)$|[\"\'])/g, ''),
      $img = $('<img>').attr('src', src).on('load', function() {
        setTimeout(() => {
          $('.carousel-component').attr('style', '')
        }, 0)
      });
  }



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/carousel-fixed-height.js